import React, { useState, useEffect,useRef } from 'react';
import { useCookies } from 'react-cookie';
import { useHistory, Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Chat(props) {
	const { state } = props.location;
	console.log(state);
	const [kdData] = useState(state[0]);
	let history = useHistory();
  	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
	// const [chatId, setCgId] = useState(0);
	let textInput = React.createRef();
	const messageEl = useRef(null);
	const [chatMessages , setChatMessages] = useState([]);
	const messages = [];
	const [cgData, setCgData] = useState([]);
	var setOldId = 0;
	useEffect(() => {
		getChatData();
		const interval = setInterval(() => {
			if(localStorage.getItem("cg_id") != ''){
				getChat(localStorage.getItem("cg_id"), '');
			}
		}, 60000);
		return () => {clearInterval(interval)};
	}, []);

	const prevScrollY = useRef(0);
	const [goingUp, setGoingUp] = useState(false);

	const onScroll = (e) => {
		const currentScrollY = e.target.scrollTop;

		if (prevScrollY.current < currentScrollY && goingUp) {
		setGoingUp(false);
		}
		if (prevScrollY.current > currentScrollY && !goingUp) {
		setGoingUp(true);
		}
		if(goingUp && currentScrollY === 0){
			getChat(localStorage.getItem("cg_id"), localStorage.getItem("old_msg"));
		}
		prevScrollY.current = currentScrollY;
		console.log(goingUp, currentScrollY);
		console.log(window.innerHeight);
		// console.log(document.documentElement.scrollTop);
		console.log(e.target.scrollHeight);
		if (window.innerHeight +currentScrollY - 280 === e.target.scrollHeight) {
			// Do load more content here!
			console.log("bottom");
		}
	};

	// const [error1, setError] = useState(false);
	const getChatData = async () => {
		console.log("------");
		localStorage.setItem("m2",JSON.stringify([]));
		localStorage.setItem("old_msg", 0);
		localStorage.setItem("last_msg_id", 0);
		let user_data = localStorage.getItem("chat_users");
		var cgid = localStorage.getItem("cg_id");
		if(user_data && cgid){
			user_data = JSON.parse(localStorage.getItem("chat_users"));
			setCgData(user_data);
			// setCgId(cgid);
		} else {
			let k_id = '';
			if(kdData.k_id != undefined){
				k_id = kdData.k_id;
			}
			const requestOptions = {
				method: 'POST',
				headers: {'Content-Type': 'application/json','token':token,'userId':user_id},
				body: JSON.stringify({dist_user_id:user_id,k_id:k_id}),
			};
			console.log(requestOptions);
			const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-chat-group', requestOptions);
			const data = await response.json();
			if (data.status !== "success"){
				// setError(true);
			}
			localStorage.setItem("chat_users", JSON.stringify(data.user_data));
			localStorage.setItem("cg_id", JSON.stringify(data.cg_id));
			user_data = data.user_data;
			setCgData(data.user_data);
			cgid = data.cg_id
			// setCgId(data.cg_id);
		}
		setOldId = 1;
		if(state[1] === "send"){
			state[1] = "";
			sendChat(state[2],"war_request");
		} else {
			getChat(cgid, '');
		}
		
	};

	async function getChat(cg_id, getOld=''){
		console.log("getting chat ...");
		var off_set = 0;
		if(getOld !== ''){
			off_set = parseInt(getOld);
		}
		var id = 0;
		if (getOld === ''){
			id = localStorage.getItem("last_msg_id");
		}
		const requestOptions = {
			method: 'POST',
			headers: {'Content-Type': 'application/json','token':token,'userId':user_id},
			body: JSON.stringify({user_id:user_id,cg_id:cg_id,limit:20,offset:off_set,latest_message:id}),
		};
		console.log(requestOptions);
		const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-chat', requestOptions);
		const data = await response.json();
		console.log(data);
		if(data.status !== undefined && data.status === "success"){
			if(data.messages.length > 0){
				var mm2 = [];
				var oldMsgCnt = localStorage.getItem("old_msg");
				console.log(oldMsgCnt);
				if(oldMsgCnt && getOld !== ''){
					let m = parseInt(oldMsgCnt) + data.messages.length;
					localStorage.setItem("old_msg", m);
				} else if(getOld !== '') {
					localStorage.setItem("old_msg", parseInt(data.messages.length));
				} else if (setOldId === 1) {
					setOldId = 0;
					localStorage.setItem("old_msg", parseInt(data.messages.length));
				}
				// console.log(localStorage.getItem("old_msg"));
				if (getOld === ''){
					// console.log("-----------------------------" + data.latest_message);
					localStorage.setItem("last_msg_id", data.latest_message);
				}
				var user_data = JSON.parse(localStorage.getItem("chat_users"));
				for (const [index, value] of data.messages.entries()) {
					var date = new Date(value.time);
					var name = index;
					name = value.user_id;
					if(user_data[value.user_id] !== undefined ){
						if (user_data[value.user_id].dist_name !== undefined) {
							name = user_data[value.user_id].dist_name ;
						}
					}
					var sentAt = date.getDate() + "/" + (date.getMonth() + 1) + "/"  + date.getFullYear() + " ";
					let minutes = date.getMinutes();
					if (minutes <= 9){
						minutes = "0" + minutes ;
					}
					if (date.getHours() > 12){
						let hour =  date.getHours() - 12;
						if (hour < 10){
							hour = "0" + hour;
						}
						sentAt = sentAt + hour + ":" + minutes + " PM";
					} else if (date.getHours() === 0){
						sentAt = sentAt + "12:" + minutes + " AM";
					} else if (date.getHours() === 12){
						sentAt = sentAt + "12:" + minutes + " PM";
					}  else {
						let hour =  date.getHours();
						if (hour < 10){
							hour = "0" + hour;
						}
						sentAt = sentAt + hour + ":" + minutes + " AM";
					}
					var t2 = '';
					// console.log(chatMessages);
					if(value.user_id === parseInt(user_id)){
						t2 = {"id": value.id,"name":"you", "message": value.message, "sent": sentAt};
					} else {
						t2 = {"id": value.id,"name":name, "message": value.message, "sent": sentAt};
					}
					// console.log(m);
					if(getOld === ''){
						mm2.push(t2);
					} else {
						mm2.unshift(t2);
					}
				}
				let m = localStorage.getItem("m2");
				m = JSON.parse(m);
				console.log(m);
				if(getOld === ''){
					localStorage.setItem("m2",JSON.stringify(m.concat(mm2)));
					let temp = JSON.parse(localStorage.getItem("m2"));
					let tm = '';
					let tp = [];
					for (const [index, value] of temp.entries()) {
						// console.log(value);
						if(value.name === "you"){
							tm = <li className="replies" key={index +  "" +value.id}>
								<span></span>
								<p className="mb-0"><label className="mb-0 text-white font-weight-500">You</label><br/>
								{/* {value.message}  */}
								<i dangerouslySetInnerHTML={{ __html: value.message }} />
								<label className="msg-time">{value.sent}</label></p>
							</li>;
						} else {
							tm = <li className="sent"  key={index +  "" +value.id}>
								<span></span>
								<p className="mb-0"><label className="mb-0 text-black font-weight-500">{value.name}</label><br/>
								<i dangerouslySetInnerHTML={{ __html: value.message }} />
								<label className="msg-time">{value.sent}</label></p>
							</li>;
						}
						tp.push(tm);
					}
					setChatMessages(tp);

					// setChatMessages(messages.concat(chatMessages));
					if(messageEl.current){
						messageEl.current.scrollIntoView(true);
					}
				} else {
					localStorage.setItem("m2",JSON.stringify(mm2.concat(m)));
					localStorage.setItem("messages",JSON.stringify(chatMessages.concat(messages)));
					let temp = JSON.parse(localStorage.getItem("m2"));
					let tm = '';
					let tp = [];
					for (const [index, value] of temp.entries()) {
						// console.log(value);
						if(value.name === "you"){
							tm = <li className="replies" key={index +  "" +value.id}>
								<span></span>
								<p className="mb-0"><label className="mb-0 text-black font-weight-500">You</label><br/>
								<i dangerouslySetInnerHTML={{ __html: value.message }} />
								<label className="msg-time">{value.sent}</label></p>
							</li>;
							console.log("here");
						} else {
							tm = <li className="sent"  key={index +  "" +value.id}>
								<span></span>
								<p className="mb-0"><label className="mb-0 text-black font-weight-500">{value.name}</label><br/>
								<i dangerouslySetInnerHTML={{ __html: value.message }} />
								<label className="msg-time">{value.sent}</label></p>
							</li>;
						}
						tp.push(tm);
					}
					setChatMessages(tp);
					// setChatMessages(chatMessages.concat(messages));
					// console.log(chatMessages);	
				}
			}
		}
	}

	async function sendChat(msg, msgType){
		console.log("sending chat ...");
		if(msgType !== "war_request"){
			msg = textInput.current.value;
			textInput.current.value = '';
		}
		console.log(textInput);
		let cgid = localStorage.getItem("cg_id");
		if(msg !== '') {
			const requestOptions = {
				method: 'POST',
				headers: {'Content-Type': 'application/json','token':token,'userId':user_id},
				body: JSON.stringify({user_id:user_id,message:msg,cg_id:cgid,type:msgType}),
			};
			console.log(requestOptions);
			const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'send-chat', requestOptions);
			const data = await response.json();
			if(data.status === "success"){
				getChat(cgid, '');
			}
		}
	}
 	return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/group-chats.css'}]
	}/>
	<div className="row no-gutters">
	  	<div className="application bg-grey">
		  	{/* <div style=
				{{
					backgroundImage: `url(${kdData.kd_image}), linear-gradient(
				144deg, #997A5C, #6D6264, rgba(0, 0, 0, 0.25))`,
					backgroundBlendMode: `multiply`,
					backgroundSize: `100% 100%`,
					backgroundPosition: `left`,
					borderBottomLeftRadius: `8px`,
					borderBottomRightRadius: `8px`,
					height: `84px`,
					backgroundRepeat: `no-repeat`
				}}> */}
			<div className="bg-gradient1">
				<div className="appHeader bg-transparent text-light position-relative">
					<div className="left">
						<div className="headerButton goBack" onClick={() => history.goBack()}>
							<img src={require("./../images/back.png").default} alt="faq" className="img-fluid" />
						</div>
					</div>
					<div className="pageTitle">Kingdom {kdData.kd_name}</div>
					<div className="right">
						<Link to="/faq" className="headerButton">
							<img src={require("./../images/faq.png").default} alt="faq" className="img-fluid" />
						</Link>
					</div>
				</div>
			</div>

			<div className="section bg-white action-sheet p-0">
		
		  		<div className="row chat m-auto" style={{height: `calc(100vh - 120px)`}}>
			  		<div className="card">
				  		<div className="card-header">
							<div className="row d-flex justify-content-center">
					  			<div className="d-inline-block grp-chat">
									<p> Group Updates </p>
					  			</div>
					 			<div className="ml-auto d-inline-block">
									
										<Link to={{
											pathname:"/view-members",
											state: [cgData,kdData]
										}}>
											View Members
										</Link>
									
					 			</div>
							</div>
				  		</div>
				  		<div className="card-body">
							{/* <div className="container">
					  			<div className="row  justify-content-center">
									<div className="col-12 col-md-10 col-lg-10">
										<div className="mughal">
											<p className="text-center mb-0">MAURYA DEFEATS MUGHAL!<br/>Wealth points are doubled for Maurya.</p>
										</div>
									</div>
					  			</div>
							</div> */}
							<div className="row justify-content-center">
					  			<div className="chats" onScroll={onScroll} >
									<div className="messages">
						  				<ul className="mt-2" >
										  {/* <div dangerouslySetInnerHTML={{__html: chatMessages }} ></div> */}
											{(chatMessages)}
											<li ref={messageEl}></li>
						  				</ul>
									</div>
					  			</div>
							</div>
							{ localStorage.getItem("user_type") !== "distributor" && (
							<div className="send">
					  			<div className="input-group sendmessage align-self-center">
									<textarea ref={textInput} className="form-control" rows="1" aria-label="With textarea" placeholder="Type your message here" ></textarea>
									<div className="input-group-append">
						  				<div className="input-group-text p-2" onClick={() => sendChat('up',"normal")} style={{borderBottom: `1px solid rgb(0 0 0 / 8%)`}}><img src={require("./../images/send.png").default} alt=""/></div>
									</div>
					  			</div>
							</div>
							)}
				  		</div>
			  		</div>
		  		</div>
			</div>
	  	</div>
		<div className="bg"></div>
	</div>
</>
  	);
}

export default Chat;
